module.exports = __webpack_public_path__ + "static/media/Nguyen_Dong_Duc_Anh.6083434a.jpg";